import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencyBar() {
  return <div className="bg-brand-peach border-y-2 border-brand-yellowDark py-5 px-4 text-center" data-id="element-261">
      <p className="font-display font-bold text-brand-redDark text-base md:text-2xl uppercase tracking-wide mb-3 animate-pulse" data-id="element-262">
        ⏰ El Precio de Lanzamiento Termina En:
      </p>
      <CountdownTimer data-id="element-263" />
      <p className="text-xs md:text-sm text-brand-navy font-bold uppercase tracking-widest mt-3" data-id="element-264">
        Después sube el precio y los bonos no estarán incluidos
      </p>
    </div>;
}